// extracted by mini-css-extract-plugin
export var mobileNav = "mobile-nav-module--mobile-nav--Id8XB";
export var hamburger = "mobile-nav-module--hamburger--taano";
export var sidenav = "mobile-nav-module--sidenav--5J2po";
export var backgroundBlur = "mobile-nav-module--background-blur--1VAFQ";